import React, {createContext, useReducer} from "react";
import {AppNavigationActions} from "../actions/AppNavigationActions";
import {AppNavigationReducer} from "../reducers/AppNavigationReducer";
import {Colors} from "../../utils/Colors";
import {injectIntl} from "react-intl";

export const AppNavigationContext = createContext();

const AppNavigationContextProvider = (props) => {
    const initState = {
        title: props.intl.formatMessage({id: "induct"}),
        navColor: Colors.NAV_COL,
        backEnabled: true,
        helpEnabled: false,
        onBackClicked: null,
        helpOptions: {
            open: false,
            title: "Help Center",
            pageTitle: "",
            list: []
        },
    };

    const [navState, navDispatch] = useReducer(AppNavigationReducer, initState);

    const setupHelp = (enabled, options) => {
        navDispatch({type: AppNavigationActions.SETUP_HELP, value: {enabled, options}});
    }

    const openHelp = () => {
        navDispatch({type: AppNavigationActions.OPEN_HELP});
    }

    const closeHelp = () => {
        navDispatch({type: AppNavigationActions.CLOSE_HELP});
    }

    const errorNavCol = () => {
        navDispatch({type: AppNavigationActions.ERROR_COL});
    }

    const resetNavCol = () => {
        navDispatch({type: AppNavigationActions.RESET_COL});
    }

    const closeOnBack = () => {
        navDispatch({type: AppNavigationActions.CLOSE_ON_BACK});
    }

    const onBackDefault = () => {
        navDispatch({type: AppNavigationActions.ON_BACK_DEFAULT});
    }

    return (
        <AppNavigationContext.Provider value={{
            navState, navActions: {
                setupHelp,
                openHelp,
                closeHelp,
                errorNavCol,
                resetNavCol,
                closeOnBack,
                onBackDefault
            }
        }}>
            {props.children}
        </AppNavigationContext.Provider>
    )
}

export default injectIntl(AppNavigationContextProvider);


// WEBPACK FOOTER //
// ./src/components/appNavigation/context/AppNavigationContext.js